import { AccountFeatures, AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import { useQuery } from "react-query"
import { integrationKeyRainforest } from "../../integration/IntegrationConstants"
import LocationSelect from "../../integration/LocationSelect"
import TestModeAlert from "../../payment-processing/components/TestModeAlert"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import Location from "../../state/location/Location.js"
import LocationService from "../../state/location/LocationService"
import GlobalHelper from "../GlobalHelper"
import { SelectOption } from "../types/select/types"
import NewRainforestBankAccountWrapper from "./rainforest/NewRainforestBankAccountWrapper"

type Props = {
    contactId: string,
    integrationKey: INTEGRATION_KEY,
    onClose: () => void,
    onSubmit: () => void,
    locationId?: string
}

const NewBankAccountOnFileModal = (props: Props) => {

    const [locationID, setLocationID] = useState<string>(props.locationId || "")
    const [locations, setLocations] = useState<Location[]>([])
    const [selectedLocation, setSelectedLocation] = useState<SelectOption<string>>()
    const { isLoading: isLoadingLocations, isFetched } = useQuery(["getLocations"], async () => {
        return LocationService.fetchAllLocations()
    }, {
        onSuccess: (locations : Location[]) => {
            const availableLocations = locations.filter((location) => (location.getEnabled() && GlobalHelper.isLocationAssignedToIntegrationKey(
                location.getId(), GlobalHelper.getFirstIntegrationKeyFoundWithEnabledFeature(AccountFeatures.FeatureIntegratedBankTransfer))))
            setLocations(availableLocations)
        },
    })


    const getModalBody = (integrationKey: string) => {
        switch (integrationKey) {
        case integrationKeyRainforest:
            return <>
                {(!props.locationId && AppContext.locations.length > 0) &&
                <div className="modal-body pl-4">
                    {locations.length == 0 && isFetched ? <FormattedMessage
                        id="customer.bank_account_on_file.no_locations"
                        defaultMessage="Enable or assign locations to the payment integration to add a new payment method."/> :
                        <LocationSelect
                            locations={locations}
                            isLoadingLocations={isLoadingLocations}
                            selectedLocationIds={selectedLocation}
                            onSelect={(loc) => {
                                setLocationID(loc.value)
                                setSelectedLocation(loc)
                            }}
                            multi={false}
                        />}
                </div>}
                {(locationID || AppContext.locations.length === 0) && <NewRainforestBankAccountWrapper
                    contactId={props.contactId}
                    refreshContact={() => {
                        props.onSubmit()
                        props.onClose()
                    }}
                    locationId={locationID}/>}
            </>
        default:
            return <div>
                <FormattedMessage
                    id="customer.bank_account_on_file.not_supported"
                    defaultMessage="The payment integration is not currently supported or hasn't been enabled"/>
            </div>
        }
    }

    return (
        <Modal
            onHide={props.onClose}
            show={true}
            backdrop="static">
            <Modal.Header>
                <Modal.Title>
                    <FormattedMessage
                        id="customers.bank_accounts_on_file.new.label"
                        defaultMessage="Add a new account on file"
                    />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TestModeAlert />
                {getModalBody(props.integrationKey)}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={props.onClose}
                    variant="secondary">
                    <FormattedMessage id="core.modal.close_button_label" defaultMessage="Close"/>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default injectIntl(NewBankAccountOnFileModal)


// WEBPACK FOOTER //
// ./src/common/bank-account/NewBankAccountOnFileModal.tsx